import script from "./Mbank-Invite.vue?vue&type=script&setup=true&lang=js"
export * from "./Mbank-Invite.vue?vue&type=script&setup=true&lang=js"

import "./Mbank-Invite.vue?vue&type=style&index=0&id=e163c756&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e163c756"]])

export default __exports__